<template>
  <div>
    <v-data-table
        :headers='keys'
        :class="'elevation-1 row-pointer ff border'"
        :footer-props="{itemsPerPageText: 'Строк на странице'}"
        :hide-default-footer="hideFooter"
        :items='items'
        :search="search"
        :items-per-page="itemCounts"
        style='border: 2px solid black!important'
    >
      <template #body='{ items, headers }'>
        <tbody>
        <tr v-for='(item, index) in items' :key='index'
            @click='rowClicke(item)'
            :class='thisColor(item)'
        >
          <td v-for='(n,i) in headers' :key='i'>
            <slot :name='n.value' :object='item' :value='item[n.value]'>
              {{ item[n.value] }}
            </slot>
          </td>
        </tr>
        </tbody>
      </template>
    </v-data-table>
    <div v-if="count > 1" class="mt-5 text-center">

      <v-pagination
          v-model="page"
          :length="count"
          :total-visible="5"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
      ></v-pagination>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      theme: localStorage.getItem("theme"),
      page: 1
    }
  },
  props: {
    keys: Array,
    search: String,
    itemCounts: {
      type: Number,
      default() {
        return 10
      }
    },
    items: Array,
    rowClick: Function,
    hideFooter: Boolean,
    color: Function,
    paginate: Object
  },
  created() {


    this.keys.forEach(k => {
      k.align = 'center'
    })
    this.page = parseInt(this.currentPage || 1)
    // this.$emit('paginateAction', this.page)

  },
  methods: {
    rowClicke(item) {
      if (this.rowClick) {
        this.rowClick(item)
      }
    }
  },
  computed: {
    thisColor() {
      return this.color || (() => {
      })
    },
    count() {
      return this?.paginate?.count
    },
    path() {
      return this.$route.path
    },
    fullPath() {
      return this.$route.fullPath
    }
  },
  watch: {
    page(page) {
      const currentPath = `${this.path}?page=${page}`
      if (this.fullPath === currentPath) return
      this.$router.push(`${this.path}?page=${page}`)
      this.$emit('paginateAction', (page - 1) * 10)
    }
  }
}
</script>

<style lang='css' scoped>
.row-pointer >>> tbody {
  text-align: center !important;
  font-weight: bold !important;
}

.row-pointer >>> tbody:hover {
  cursor: pointer !important;
}

.row-pointer >>> thead tr th {
  font-weight: bolder !important;
  text-shadow: 0 0 1px black !important;
  font-size: 14px !important;
  text-transform: uppercase !important;
  position: relative;
  text-align: center !important;
  padding: 0 50px !important;
}

.row-pointer >>> thead {
  padding: 10px !important;
  outline: 3px solid black !important;
}

.row-pointer >>> thead tr th :after {
  content: '';
  position: absolute;
  left: 50%;
  margin-left: 50% !important;
  top: 0;
  height: 1500px !important;
  border-left: 2px solid grey !important;
  z-index: 1;
}

.row-pointer >>> thead tr th {
  opacity: 1;
}

.red-color {
  background-color: #ff0000 !important;
  color: white;
  opacity: 0.8;
}

.warning-color {
  background-color: #ffff00 !important;
  opacity: 0.9;
}

.success-color {
  background-color: #00b24f !important;
  color: white;
  opacity: 0.8;
}

</style>
